import type { IBuildingCard } from 'shared/types/buildingCard';
import type { TApplicationState } from 'shared/types/redux';

export const selectBuildingCard = (state: TApplicationState): IBuildingCard => state.buildingCard;
